'use client'
import ShortListingCard from '@/app/[lng]/components/Cards/ShortListingCard'
import ShortCardSkeleton from '@/app/[lng]/components/Skeletons/shortCardSkeleton'
import CustomErrorBoundary from '@/app/[lng]/ErrorBoundary'
import { useGetRelatedOffersQuery } from '@/app/globalRedux/api/offer/offerAPI'
import useLocalizedRouter from '@/app/hooks/useLocalizedRouter'
import { useTranslation } from '@/app/i18n/client'
import { Button } from '@/components/ui/button'
import Image from 'next/image'

const AlternateOffers = ({ offerId }: { offerId: number }) => {
  const pushWithLocale = useLocalizedRouter()
  const { t } = useTranslation()
  const { data: relatedList, isLoading: isRelatedLoading } =
    useGetRelatedOffersQuery<{
      data: any
      isLoading: boolean
    }>(offerId)

  return (
    <div className="flex flex-col gap-5 my-8 w-[60rem] mobile-width mobile:my-2 mobile:gap-[10px]">
      <h2 className="text-xl font-ns_bold">{t('Alternative Offers')}</h2>
      <div className="overflow-x-auto grid grid-wrap grid-cols-3 gap-7 h-90 mobile:flex-col mobile:gap-[10px]">
        {relatedList != null ? (
          relatedList?.sales_offers?.map((item: any, index: number) => (
            <CustomErrorBoundary
              key={`Alternate_sales_card_${item.offer.id}_${index}`}
            >
              <ShortListingCard cardData={item.offer} cardType="Seller" />
            </CustomErrorBoundary>
          ))
        ) : (
          <ShortCardSkeleton count={3} />
        )}
      </div>
      <div className="font-ns_bold">
        {!isRelatedLoading &&
          relatedList != null &&
          relatedList?.sales_offers?.length > 0 && (
            <Button
              variant="secondary"
              size="sx"
              onClick={() => {
                pushWithLocale('/sales-listing')
              }}
            >
              {t('View All')}
            </Button>
          )}
      </div>
      {!isRelatedLoading &&
        relatedList != null &&
        relatedList?.sales_offers?.length === 0 && (
          <div className="p-16 flex flex-col gap-2 items-center justify-center text-primary-foreground">
            <Image
              loading="lazy"
              width={76}
              height={93}
              src="/assets/Icons/noImage/noOfferIcon.svg"
              alt=""
              className="w-[76px] h-[96px] object-cover border"
            />
            <div className="flex">
              {t(
                'Currently there no Alternative Offers available at this moment.'
              )}
            </div>
          </div>
        )}
    </div>
  )
}

export default AlternateOffers
